import React from "react";
import { YojnaTrackerContextProvider } from "../../context/yojnaTrackerContext";
import YojnaTrackerBoard from "../../components/YojnaTracker/YojnaTrackerBoard";

const YojnaTracker = () => {
  return (
    <YojnaTrackerContextProvider>
      <YojnaTrackerBoard />
    </YojnaTrackerContextProvider>
  );
};

export default YojnaTracker;
